import React from "react";
import "./SharePopup.css";
import {
    WhatsappIcon,
    WhatsappShareButton,
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    TwitterShareButton,
    TwitterIcon,
} from "react-share";

const SharePopup = ({ onClose }) => {
    const link = "https://youtu.be/your-video-id"; // Change this

    const copyText = () => {
        navigator.clipboard.writeText(link);
        alert("Link Copied!");
    };

    return (
        <div className="yt-overlay">
            <div className="yt-popup">
                
                {/* Header */}
                <div className="yt-header">
                    <h3>Share</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                {/* Icons Row */}
                <div className="yt-icons-scroll">
                    
                    <div className="yt-icon-group">
                        <WhatsappShareButton url={link}>
                            <WhatsappIcon size={55} round />
                        </WhatsappShareButton>
                        <p>WhatsApp</p>
                    </div>

                    <div className="yt-icon-group">
                        <FacebookShareButton url={link}>
                            <FacebookIcon size={55} round />
                        </FacebookShareButton>
                        <p>Facebook</p>
                    </div>

                    <div className="yt-icon-group">
                        <TwitterShareButton url={link}>
                            <TwitterIcon size={55} round />
                        </TwitterShareButton>
                        <p>X</p>
                    </div>

                    <div className="yt-icon-group">
                        <EmailShareButton url={link}>
                            <EmailIcon size={55} round />
                        </EmailShareButton>
                        <p>Email</p>
                    </div>

                </div>

                {/* Link Box */}
                <div className="yt-link-box">
                    <input value={link} readOnly />
                    <button onClick={copyText}>Copy</button>
                </div>

            </div>
        </div>
    );
};

export default SharePopup;
